import { ConfigService } from "./../../services/config.service";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { AccountService } from "src/app/services/account.service";
import { environment } from "src/environments/environment";
import { UrlConstants } from "src/app/models/urlConstants";

export interface AlertObject {
  symbol;
  status;
  notifications;
  expirationDate;
  triggeredDate;
  id;
}

@Component({
  selector: "app-alert-manager",
  templateUrl: "./alert-manager.component.html",
  styleUrls: ["./alert-manager.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class AlertManagerComponent implements OnInit {
  isAlertsLoading: boolean = false;

  columnsToDisplay = [
    "symbol",
    "status",
    "notifications",
    "expirationDate",
    "triggeredDate",
    "id",
  ];
  expandedElement: AlertObject | null;

  activeAlerts = [
    {
      symbol: "EGS65091C018",
      status: "Expired",
      notifications: "All",
      expirationDate: new Date(),
      triggeredDate: new Date(),
      id: "124124124",
    },
    {
      symbol: "EGS65091C018",
      status: "Expired",
      notifications: "All",
      expirationDate: new Date(),
      triggeredDate: new Date(),
      id: "124124124",
    },
    {
      symbol: "EGS65091C018",
      status: "Expired",
      notifications: "All",
      expirationDate: new Date(),
      triggeredDate: new Date(),
      id: "124124124",
    },
  ];

  constructor(private http: HttpClient, private accService: AccountService) {
    // this.fetchUserAlerts();
  }

  fetchUserAlerts() {
    this.isAlertsLoading = true;

    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=1001-1`
      )
      .subscribe((res) => {
        this.isAlertsLoading = false;
        // this.activeAlerts = res;
      });
  }
  ngOnInit(): void {}
}
